
import {Mixins, Component, Prop} from 'vue-property-decorator';
import SimpleInputMixin from "@/mixins/SimpleInputMixin.vue";

@Component({})
export default class KurumAdi extends Mixins(SimpleInputMixin) {
  @Prop() uyapSorgula !: string | boolean;
  @Prop() rules !: any;

  get isUyapSorgulaButton() {
    return this.uyapSorgula || this.uyapSorgula === "";
  }

  async sorgula() {
    let formatedKurumAdi = btoa(this.localValue);
    let cevap = await this.$uyap.KurumAutoSearch().run({kurumAdi:formatedKurumAdi});
    this.$emit('uyap', cevap);
  }
}
